import React, {useEffect, useRef, useState} from 'react'
import {Button} from "primereact/button";

// so lange ist der Knopf zum Einblenden einer Leiste deutlich sichtbar, danach fast transparent
const EINBLENDEN_SICHTBAR_MS = 10000;

/**
 * Zustand einer ausblendbaren Leiste im Vollbild. Beim Verlassen des Vollbilds wird die Leiste wieder eingeblendet,
 * damit sie beim nächsten Öffnen sichtbar ist.
 * @returns [leisteAus, setLeisteAus]
 */
export function useLeisteAusblendbar(vollbild) {
    const [leisteAus, setLeisteAus] = useState(false);
    useEffect(() => {
        if (!vollbild) {
            setLeisteAus(false);
        }
    }, [vollbild]);
    return [leisteAus, setLeisteAus];
}

/**
 * Knopf in einer Leiste im Vollbild, blendet die Leiste aus, damit mehr Platz für den Inhalt bleibt.
 */
export function LeisteAusblendenKnopf({label = "Menü ausblenden", onClick}) {
    return <Button icon="pi pi-chevron-up" className="p-button-sm p-button-outlined dhpt-button-hell"
                   aria-label={label} title={label} onClick={onClick}/>
}

/**
 * Kleiner Knopf zum Einblenden einer ausgeblendeten Leiste, liegt oben rechts über dem Inhalt.
 * Nach 10 Sekunden wird er fast transparent, fährt man mit der Maus darauf (oder tippt ihn an),
 * ist er wieder für 10 Sekunden deutlich sichtbar.
 *
 * @param oben true für die Leiste ganz oben im Vollbild (berücksichtigt Notch/Statusleiste)
 */
export function LeisteEinblendenKnopf({label = "Menü einblenden", oben, onClick}) {

    const [blass, setBlass] = useState(false);
    const timer = useRef(undefined);

    const zeigen = () => {
        setBlass(false);
        clearTimeout(timer.current);
        timer.current = setTimeout(() => setBlass(true), EINBLENDEN_SICHTBAR_MS);
    }

    useEffect(() => {
        zeigen();
        return () => clearTimeout(timer.current);
    }, []);

    const knopf = <Button icon="pi pi-chevron-down" aria-label={label} title={label} onClick={onClick}
                          className={"p-button-sm p-button-rounded dhpt-leiste-einblenden" + (blass ? " dhpt-leiste-einblenden-blass" : "")}
                          onPointerEnter={zeigen} onPointerDown={zeigen} onFocus={zeigen}/>;

    if (!oben) {
        return <div className="dhpt-leiste-einblenden-ecke">{knopf}</div>
    }
    // obere Leiste ausgeblendet: oben rechts fest das Logo als Wasserzeichen, links neben dem Knopf
    return <div className="dhpt-leiste-einblenden-ecke dhpt-leiste-einblenden-oben">
        <img className="dhpt-vollbild-wasserzeichen" src="/images/darthelfer_quer_weiss.png" alt="" aria-hidden="true" draggable={false}/>
        {knopf}
    </div>
}
